export type RealtimeEventPayload =
  | {
      type: 'scenario-presence';
      scenarioName: string;
      updatedAt: string;
    }
  | {
      type: 'scenario-library';
      scenarioName?: string;
      previousScenarioName?: string | null;
      updatedAt: string;
    }
  | {
      type: 'scenario-snapshot';
      scenarioName: string;
      updatedAt: string;
    }
  | {
      type: 'catalog';
      updatedAt: string;
    };

export const REALTIME_SCENARIO_PRESENCE_EVENT = 'tableArrangement:realtime-scenario-presence';
export const REALTIME_SCENARIO_LIBRARY_EVENT = 'tableArrangement:realtime-scenario-library';
export const REALTIME_SCENARIO_SNAPSHOT_EVENT = 'tableArrangement:realtime-scenario-snapshot';
export const REALTIME_CATALOG_EVENT = 'tableArrangement:realtime-catalog';

export function dispatchRealtimeBrowserEvent(event: RealtimeEventPayload) {
  if (typeof window === 'undefined') {
    return;
  }

  const eventName =
    event.type === 'scenario-presence'
      ? REALTIME_SCENARIO_PRESENCE_EVENT
      : event.type === 'scenario-library'
        ? REALTIME_SCENARIO_LIBRARY_EVENT
        : event.type === 'scenario-snapshot'
          ? REALTIME_SCENARIO_SNAPSHOT_EVENT
          : REALTIME_CATALOG_EVENT;

  window.dispatchEvent(new CustomEvent<RealtimeEventPayload>(eventName, { detail: event }));
}
